import { createGlobalStyle } from 'styled-components'

export const GlobalStyles = createGlobalStyle`
  /* Import Google Fonts */
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Open+Sans:wght@300;400;500;600;700&family=Crimson+Text:wght@400;600;700&display=swap');

  /* CSS Reset */
  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html {
    font-size: 16px;
    scroll-behavior: smooth;
  }

  body {
    font-family: ${props => props.theme.fonts.body};
    color: ${props => props.theme.colors.dark};
    background-color: ${props => props.theme.colors.light};
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: ${props => props.theme.fonts.heading};
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: ${props => props.theme.spacing.md};
  }

  h1 {
    font-size: clamp(2rem, 5vw, ${props => props.theme.fontSizes['5xl']});
  }

  h2 {
    font-size: clamp(1.5rem, 4vw, ${props => props.theme.fontSizes['4xl']});
  }

  h3 {
    font-size: clamp(1.25rem, 3vw, ${props => props.theme.fontSizes['3xl']});
  }

  h4 {
    font-size: ${props => props.theme.fontSizes['2xl']};
  }

  h5 {
    font-size: ${props => props.theme.fontSizes.xl};
  }

  h6 {
    font-size: ${props => props.theme.fontSizes.lg};
  }

  p {
    margin-bottom: ${props => props.theme.spacing.md};
  }

  a {
    color: ${props => props.theme.colors.primary};
    text-decoration: none;
    transition: color ${props => props.theme.transitions.fast};

    &:hover {
      color: ${props => props.theme.colors.secondary};
    }
  }

  img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  button {
    cursor: pointer;
    font-family: inherit;
    font-size: inherit;
    border: none;
    background: none;
  }

  ul, ol {
    list-style: none;
  }

  /* Utility classes */
  .container {
    width: 100%;
    max-width: ${props => props.theme.breakpoints.wide};
    margin: 0 auto;
    padding: 0 ${props => props.theme.spacing.md};

    @media (min-width: ${props => props.theme.breakpoints.tablet}) {
      padding: 0 ${props => props.theme.spacing.lg};
    }
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  /* Smooth scrolling for all browsers */
  @media (prefers-reduced-motion: reduce) {
    html {
      scroll-behavior: auto;
    }
    
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      animation-iteration-count: 1 !important;
      transition-duration: 0.01ms !important;
    }
  }
`